import React, { useState } from 'react';
import { productsAPI } from '../api';

export default function RecipeModal({ productId, trial, materials, onClose, onSaved }) {
  const [ingredients, setIngredients] = useState(materials.map(m => ({ ...m, selected: true })));
  const [notes, setNotes] = useState('');
  const [batchSize, setBatchSize] = useState('');
  const [batchUnit, setBatchUnit] = useState('kg');
  const selected = ingredients.filter(i => i.selected);
  const total = selected.reduce((s, i) => s + (i.total_cost || 0), 0);
  const totalRMKg = selected.reduce((s, i) => { const u = (i.unit||'kg').toLowerCase(); return s + (['g','gm','gram','grams','ml'].includes(u) ? (parseFloat(i.quantity)||0)/1000 : (parseFloat(i.quantity)||0)); }, 0);
  const yieldPct = batchSize && totalRMKg > 0 ? ((parseFloat(batchSize)/totalRMKg)*100).toFixed(1) : null;

  const save = async () => {
    const userName = (() => { try { const u = JSON.parse(localStorage.getItem('npd_user')); return u?.name || u?.username || ''; } catch { return ''; } })();
    await productsAPI.saveRecipe(productId, { trial_id: trial.id, notes, confirmed_by: userName, batch_size: parseFloat(batchSize)||null, batch_unit: batchUnit, ingredients: selected.map(i => ({ item_code: i.item_code, item_name: i.item_name, quantity: i.quantity, unit: i.unit, unit_cost: i.unit_cost, total_cost: i.total_cost })), has_brine: false, brineIngredients: [] });
    onSaved();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-xl" onClick={e => e.stopPropagation()}>
        <div className="modal-header"><div className="modal-title">Confirm Recipe — Trial #{trial.trial_number}</div><button className="modal-close" onClick={onClose}>×</button></div>
        <p className="text-muted" style={{ marginBottom: 16, fontSize: 13 }}>Select ingredients to include in the confirmed recipe.</p>
        <div className="table-wrap" style={{ maxHeight: 360, overflowY: 'auto', marginBottom: 16 }}>
          <table>
            <thead><tr><th>✓</th><th>Code</th><th>Name</th><th>Qty</th><th>Unit Cost</th><th className="text-right">Total</th></tr></thead>
            <tbody>
              {ingredients.map((ing, idx) => (
                <tr key={ing.id} style={{ opacity: ing.selected ? 1 : 0.4 }}>
                  <td><input type="checkbox" checked={ing.selected} style={{ width: 'auto' }} onChange={e => { const c = [...ingredients]; c[idx] = { ...c[idx], selected: e.target.checked }; setIngredients(c); }} /></td>
                  <td className="mono">{ing.item_code}</td>
                  <td>{ing.item_name || '—'}</td>
                  <td className="mono">{ing.quantity} {ing.unit}</td>
                  <td className="mono">AED {(ing.unit_cost || 0).toLocaleString('en-AE', { maximumFractionDigits: 2 })}</td>
                  <td className="text-right cost-value">AED {(ing.total_cost || 0).toLocaleString('en-AE', { maximumFractionDigits: 2 })}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="form-group" style={{ marginBottom: 16 }}><label>Recipe Notes</label><textarea placeholder="Processing notes, storage conditions..." value={notes} onChange={e => setNotes(e.target.value)} /></div>
        <div style={{ display: 'flex', gap: 12, marginBottom: 12, alignItems: 'flex-end' }}>
          <div className="form-group" style={{ margin: 0, flex: 1 }}>
            <label>Batch Size (finished product)</label>
            <input type="number" placeholder="e.g. 100" value={batchSize} onChange={e => setBatchSize(e.target.value)} />
          </div>
          <div className="form-group" style={{ margin: 0, width: 80 }}>
            <label>Unit</label>
            <select value={batchUnit} onChange={e => setBatchUnit(e.target.value)}>
              <option value="kg">kg</option>
              <option value="g">g</option>
              <option value="l">l</option>
            </select>
          </div>
          {yieldPct && <div style={{ paddingBottom: 8, fontSize: 13, color: 'var(--accent)', fontWeight: 600 }}>Yield: {yieldPct}%</div>}
        </div>
        <div style={{ padding: '12px 16px', background: 'var(--accent-dim)', borderRadius: 8, fontFamily: 'DM Mono, monospace', fontSize: 13 }}>
          <span className="text-accent">Total: AED {total.toLocaleString('en-AE', { maximumFractionDigits: 2 })}</span>
          <span className="text-muted" style={{ marginLeft: 16 }}>{selected.length} ingredients</span>
          {totalRMKg > 0 && <span className="text-muted" style={{ marginLeft: 16 }}>Total RM: {totalRMKg.toFixed(3)} kg</span>}
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={save}>Confirm Recipe</button>
        </div>
      </div>
    </div>
  );
}
